import React, { memo } from 'react'
import { Avatar, Grid, Button } from "@mui/material";
import './styles.css'
import { injectIntl } from 'react-intl';
import moment from 'moment';


export const ItemCard = memo(function ItemCard(props) {
  console.log(props)
  console.log("props aqui 1 ")





  return (
    <Grid item xs={12} className='chatItem' style={{ cursor: props.name == "chatsInAttendance" ? 'pointer' : 'default' }} onClick={props.name == "chatsInAttendance" ? (e) => props.updateChat(e,props.chats.id) : null} >

      <Grid container spacing={0} >

        <Grid item xs={4} >
          <Grid container spacing={0}>
            <Grid item xs={12} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-evenly' }}>
              <Avatar alt={props.chats.customer ? props.chats.customer.name : ''}>
                {props.chats.customer ? props.chats.customer.name.charAt(0) : ''}
              </Avatar>
            </Grid>
            <Grid item xs={12} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-evenly' }}>
              <span> {props.chats.customer ? props.chats.customer.name : ''}</span>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={4} className='mainContent' >
          <div style={{ display: 'flex', flexDirection: 'column' }}>

            <span className='boldLine-two'> ID {props.chats.id} {props.chats.organizationname ? ' | ' + props.chats.organizationname : ''} </span>
            <span style={{ fontSize: '1.1em' }}> Provedor: {props.chats.messageprovider ? props.chats.messageprovider.name : '' + ' | '} | {props.intl.formatMessage({ id: "open.date" })}: {moment(props.chats.createdat).format('DD/MM/YYYY HH:mm')}  </span>
            {props.chats.assignedusername &&
              < span style={{ fontSize: '1.1em' }}> Técnico : {props.chats.assignedusername} </span>
            }
            < span style={{ fontSize: '1.1em' }}> {props.chats.channelid && props.chats.channelname ? "Canal: " + props.chats.channelname : null } </span>

          </div>

        </Grid>
        <Grid item xs={4} className='mainContent' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} >


          {props.name == "myChatsInAttendance"  &&

            <Button
              variant='contained'
              type="button"
              onClick={(e) => props.updateChat(e,props.chats.id)}
            >
              {props.intl.formatMessage({ id: "enter" })}
            </Button>
          }

          {props.name == "otherChatsInAttendance"  &&

            <Button
              variant='contained'
              type="button"
              //parâmetro de observar como true 
              onClick={(e) => props.updateChat(e,props.chats.id, true)}
            >
              {props.intl.formatMessage({ id: "observe" })}
            </Button>
          }

          {props.name == "chatsWaitingAttendance" &&

            <Button
              variant='contained'
              type="button"
              onClick={(e) => props.updateChat(e,props.chats.id)}
            >
              {props.intl.formatMessage({ id: "answer" })}
            </Button>
          }

        </Grid>


      </Grid>
    </Grid >
  )

})

export default injectIntl(ItemCard);